<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <BreadCrumb :data="breadcrumb" :title="'展馆详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <div v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgBox">
          <h4>封面图</h4>
          <img
            v-if="exhibitionDetail.cover_image"
            :src="exhibitionDetail.cover_image"
            alt=""
            class="form-content-img"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
          <br />
          <h4>门票背景图</h4>
          <img
            v-if="exhibitionDetail.tickets_image"
            :src="exhibitionDetail.tickets_image"
            alt=""
            class="form-content-img1"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
          <br />
          <h4>详情图</h4>
          <img
            v-if="exhibitionDetail.detail_image"
            :src="exhibitionDetail.detail_image"
            alt=""
            class="form-content-img1"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="one-third">
            <h4>中文名</h4>
            <span>{{ exhibitionDetail.chinese_name }}</span>
          </li>
          <li class="one-third">
            <h4>英文名</h4>
            <span>{{ exhibitionDetail.english_name }}</span>
          </li>
                    <li class="exclusive">
            <h4>来源</h4>
            <span>{{ exhibitionDetail.source }}</span>
          </li>
          <li class="exclusive">
            <h4>上线日期</h4>
            <span>{{ exhibitionDetail.online_time }}</span>
          </li>
          <li class="exclusive">
            <h4>展览日期</h4>
            <span>{{ exhibitionDetail.exhibition_time }}</span>
          </li>
          <li class="exclusive">
            <h4>主办方</h4>
            <span
              v-for="(item, index) in exhibitionDetail.host_organization"
              :key="index"
              >{{ item ? item.chinese_name : "" }} ;</span
            >
          </li>
          <li class="exclusive">
            <h4>主要主办方</h4>
            <span
              >{{ list ? list.chinese_name : "" }}</span
            >
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="exhibitionDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <h4>封面图</h4>
          <UploadImage
            :img="exhibitionDetail.cover_image"
            :width="230"
            :height="160"
            @getUploadImage="getUploadCoverImage"
          ></UploadImage>
          <br /><br /><br />
          <h4>门票背景图</h4>
          <UploadImage
            :img="exhibitionDetail.tickets_image"
            :width="230"
            :height="120"
            @getUploadImage="getUploadTicketsImage"
          ></UploadImage>
          <br /><br /><br />
          <h4>详情图</h4>
          <UploadImage
            :img="exhibitionDetail.detail_image"
            :width="230"
            :height="120"
            @getUploadImage="getUploadDetailImage"
          ></UploadImage>
        </div>

        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名<span>*</span></h4>
            <el-input
              v-model="exhibitionDetail.chinese_name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名<span>*</span></h4>
            <el-input
              v-model="exhibitionDetail.english_name"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
                    <li class="exclusive">
            <h4>来源</h4>
            <el-input
              v-model="exhibitionDetail.source"
              placeholder="请输入来源"
            ></el-input>
          </li>

          <li class="half">
            <h4 class="choice">上线时间</h4>
            <el-date-picker
              v-model="exhibitionDetail.online_time"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择上线日期"
            >
            </el-date-picker>
          </li>
           <li class="half">
              <h4>结束时间</h4>        
        <el-date-picker
          v-model="exhibitionDetail.exhibition_time"
          format="yyyy-MM-dd"
          type="date"
          clearable
          placeholder="选择结束日期"
        >
        </el-date-picker>
        
      
      </li>
          <li class="half">
            <h4>主办方</h4>
            <el-select
              v-model="exhibitionDetail.host_organization"
              multiple
              placeholder="请选择"
              value-key="chinese_name"
            >
              <el-option
                v-for="item in organizationList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="half">
            <h4>主要主办方</h4>
            <el-select
              v-model="exhibitionDetail.capital_organization"
              placeholder="请选择"
              value-key="chinese_name"
            >
              <el-option
                v-for="item in exhibitionDetail.host_organization"
                :key="item.label"
                :label="item.chinese_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>

          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="exhibitionDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <div class="pc-dataDetail-intro">
      <h2>展馆介绍</h2>

      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="15"
          placeholder="请输入内容"
          v-model="exhibitionDetail.chinese_introduce"
        >
        </el-input>
        <p v-else class="worksDetailIntro">
          {{
            exhibitionDetail.chinese_introduce
              ? exhibitionDetail.chinese_introduce
              : "暂无"
          }}
        </p>
      </div>
            <TranslateText
          class="translate-btn"
          v-if="isEditting"
          :chinese="exhibitionDetail.chinese_introduce"
          :english="exhibitionDetail.english_introduce"
          @returnTranslate="returnTranslate"
        />
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          v-if="isEditting"
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="exhibitionDetail.english_introduce"
        >
        </el-input>
        <p v-else class="worksDetailIntro">
          {{
            exhibitionDetail.english_introduce
              ? exhibitionDetail.english_introduce
              : "暂无"
          }}
        </p>
      </div>
    </div>
    <EditContent
      ref="exhibitionContent"
      :header="'展览'"
      :content="exhibitionDetail.detail"
      :isEditting="isEditting"
    ></EditContent>

    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import EditContent from "../../componentSet/EditContent.vue";
import TranslateText from "../../componentSet/TranslateText.vue";
import {
  getExhibitionDetail_Api,
  setExhibitionDetail_Api,
  updateExhibitionDetail_Api,
  organizationDropDown_Api,
} from "@/apis/exhibition.api";
import TagDetail from "@/components/template/TagDetail";
export default {
  components: {
    UploadImage,
    BreadCrumb,
    SaveGroup,
    TagDetail,
    EditContent,
    TranslateText
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "展馆列表", link: "/admin/exhibitionList" },
        {
          name: `${
            (
              this.exhibitionDetail.chinese_name
                ? this.exhibitionDetail.chinese_name
                : this.exhibitionDetail.english_name
            )
              ? this.exhibitionDetail.chinese_name
                ? this.exhibitionDetail.chinese_name
                : this.exhibitionDetail.english_name
              : ""
          }`,
          link: "/admin/exhibitionDetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      exhibitionDetail: {
        id: null,
        chinese_introduce: "",
        english_introduce: "",
        tickets_image: "",
        cover_image: "",
        host_organization_list: [],
        capital_organization:null,
        capital_organization_list: [],
      },
        list:{},
      organizationList: [],
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.exhibitionDetail.id = this.$route.query.id;
      this.getExhibitionDetail();
    }
    organizationDropDown_Api().then((res) => {
      this.organizationList = res.data;
    });
  },

  methods: {
        returnTranslate(data, flag) {
      flag == 1
        ? ( this.exhibitionDetail.english_introduce= data)
        : (this.exhibitionDetail.chinese_introduce = data);
      console.log(data);
      console.log(flag);
    },
    getUploadCoverImage(img_url) {
      this.exhibitionDetail.cover_image = img_url;
    },
    getUploadTicketsImage(img_url) {
      this.exhibitionDetail.tickets_image = img_url;
    },
    getUploadDetailImage(img_url) {
      this.exhibitionDetail.detail_image = img_url;
    },
    getExhibitionDetail(hint) {
      getExhibitionDetail_Api(this.exhibitionDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.exhibitionDetail = res.data;
        console.log(this.exhibitionDetail);
        var j=0;
        for(let i=0;i<this.exhibitionDetail.host_organization.length;i++){
          if(this.exhibitionDetail.host_organization[i].id == this.exhibitionDetail.capital_organization){
             j = i;
            } 
        }
        this.list = this.exhibitionDetail.host_organization[j]
        console.log(this.list)
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getExhibitionDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getExhibitionDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/exhibition/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.exhibitionDetail);
      if (!formattedData) {
        return;
      } else {
        setExhibitionDetail_Api(formattedData)
          .then((res) => {
            this.isEditting = false;
            this.exhibitionDetail.id = res.data.id;
            this.getExhibitionDetail();
            this.$router.push({
              path: "/admin/exhibitionDetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.exhibitionDetail);
      if (!formattedData) {
        return;
      } else {
        updateExhibitionDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              
              this.$global.success(this, "更新成功");
              
              this.getExhibitionDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },
    removeImgae(index) {
      this.exhibitionDetail.images_list.splice(index, 1);
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
        // formData.organization_id = formData.capital_organization.id;
            if (formData.host_organization) {
        formData.host_organization_list = formData.host_organization.map(
          (item) => {
            return item.id;
          }
        );
      }
      formData.detail = this.$refs.exhibitionContent.getContent();
      formData.images = formData.images_list;
      formData.exhibition_id = formData.id;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 30%;
}
.worksDetailIntro {
  word-break: break-all;
  text-indent: 2em;
}
/deep/ .el-select {
  width: 100%;
}
.imgBox .form-content-img {
  width: 230px;
  height: 160px;
}
.imgBox .form-content-img1 {
  width: 230px;
  height: 120px;
}
.no-img {
  width: 200px !important;
  height: 150px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/exhibition/ExhibitionDetail.vue